import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import de from "./locales/de.json";
import en from "./locales/en.json";

export const SUPPORTED_LANGUAGES = ["de", "en"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
    },
    // Static crawler output is consistently English; visitor language detection is unchanged.
    lng: typeof window !== "undefined" &&
      (window as Window & { __PRERENDER_INJECTED?: { language?: string } }).__PRERENDER_INJECTED?.language === "en"
      ? "en"
      : undefined,
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    nonExplicitSupportedLngs: true, // map "en-US" -> "en"
    load: "languageOnly",
    ...({ initImmediate: false } as object),
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "language",
      caches: ["localStorage"],
    },
  });

export default i18n;
